import { render, staticRenderFns } from "./ShowQyRy.vue?vue&type=template&id=6d6dafc0&scoped=true&"
import script from "./ShowQyRy.vue?vue&type=script&lang=js&"
export * from "./ShowQyRy.vue?vue&type=script&lang=js&"
import style0 from "./ShowQyRy.vue?vue&type=style&index=0&id=6d6dafc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6dafc0",
  null
  
)

component.options.__file = "ShowQyRy.vue"
export default component.exports